import { render } from "./AccessButtom.vue?vue&type=template&id=58cce84b&scoped=true"
import script from "./AccessButtom.vue?vue&type=script&lang=js"
export * from "./AccessButtom.vue?vue&type=script&lang=js"

import "./AccessButtom.vue?vue&type=style&index=0&id=58cce84b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cce84b"]])

export default __exports__